import { render, staticRenderFns } from "./BryntumDateField.vue?vue&type=template&id=5525375a"
import script from "./BryntumDateField.vue?vue&type=script&lang=js"
export * from "./BryntumDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports